import '../../scss/moodboard_quicksave/overlay.scss';
import '../../scss/moodboard_quicksave/modal.scss';
import '../../scss/common/components/loader.scss';
import * as React from "react";
import { render } from "react-dom";
import { QuicksaveOverlay } from "./components/QuicksaveOverlay";
function registerItemEventListeners(node) {
    var newNode = null;
    var callbackContainer = { callback: null };
    newNode = document.createElement("div");
    newNode.classList.add('tds');
    node.append(newNode);
    var slug = node.getAttribute('data-slug');
    render(React.createElement(QuicksaveOverlay, { dataLookSlug: slug, visibilityCallbackObj: callbackContainer }), newNode);
    node.addEventListener('mouseenter', function () {
        callbackContainer.callback(true);
    });
    node.addEventListener('mouseleave', function () {
        callbackContainer.callback(false);
    });
}
function initQuickSaveForAllItems() {
    document.querySelectorAll("div.photo-list-item").forEach(function (node) {
        if (node.hasAttribute('data-moodboard-quicksave')) {
            return;
        }
        node.setAttribute('data-moodboard-quicksave', '1');
        registerItemEventListeners(node);
    });
}
export function initMoodboardQuicksave() {
    initQuickSaveForAllItems();
    document.addEventListener('nextResultsFetched', function () {
        initQuickSaveForAllItems();
    });
}
export function initMoodboardQuicksaveIfConnected() {
    document.addEventListener('login:true', function () {
        initMoodboardQuicksave();
    });
}
